import { createFileRoute, Link } from '@tanstack/react-router'

import { PerRangeChart } from '@/features/brygga-stats/per-range-chart'
import { MarketPieChart } from '@/features/brygga-stats/pie-chart'
import { useBryggaStats } from '@/features/brygga-stats/use-brygga-stats'
import { getCountryFromPath } from '@/utils/base-path-params'

import styles from './brygga.module.css'

export const Route = createFileRoute('/$country/$language/brygga')({
  component: RouteComponent,
})

function getFlagEmoji(countryCode: string) {
  if (countryCode === 'ZZ') return 'global'
  return countryCode.toUpperCase().replace(/./g, (char) => String.fromCodePoint(char.charCodeAt(0) + 127397))
}

function RouteComponent() {
  const data = useBryggaStats()
  return (
    <div className={styles.mainContainer}>
      <Link from="/$country/$language/brygga" to="/$country/$language/navigator">
        {'<  back'}
      </Link>
      <h1>Model availability per market</h1>
      <div className={styles.infoContainer}>
        <div>
          <strong>info</strong>
          <ul className={styles.list}>
            <li>market: {getFlagEmoji(getCountryFromPath())}</li>
            <li>
              total ranges: <strong>{data.length}</strong>
            </li>
            <li>
              total sofas:{' '}
              <strong>
                {' '}
                {data.reduce(
                  (acc, curr) =>
                    acc +
                    curr._original.itemNos.defaultModelsAdded.length +
                    curr._original.itemNos.defaultModelsMissing.length,
                  0,
                )}
              </strong>
            </li>
          </ul>
        </div>
        <MarketPieChart data={data} />
      </div>
      <h2>Per range:</h2>
      <PerRangeChart data={data} />
    </div>
  )
}
